import React from "react";
import { Link } from "react-router-dom";
import "../css/SchoolLevel.css";
import SchoolHero from "../components/SchoolLevels/SchoolHero";

const LEVELS = [
  {
    title: "Early Childhood Education (ECCD)",
    grade: "Play Group – UKG",
    age: "Age 3 – 5 Years",

    image: "./images/a.jpeg",

    desc: "Our Early Childhood Education programme provides a joyful and caring learning environment where children develop communication skills, creativity, confidence and curiosity through play-based learning and exploration.",

    link: "/pre-primary",
  },

  {
    title: "Primary Level",
    grade: "Grade 1 – Grade 5",
    age: "Age 6 – 10 Years",

    image: "./images/primary.jpg",

    desc: "The Primary School programme builds strong academic foundations through activity-based learning. Students develop knowledge in languages, mathematics, science, technology, creativity and essential life skills.",

    link: "/primary-school",
  },

  {
    title: "Lower Secondary Level",
    grade: "Grade 6 – Grade 8",
    age: "Age 11 – 13 Years",

    image: "./images/high.jpg",

    desc: "Students strengthen conceptual understanding, critical thinking and problem-solving abilities through projects, laboratories, presentations and technology-integrated classrooms.",

    link: "/secondary-school",
  },

  {
    title: "Secondary & Higher Secondary Level",
    grade: "Grade 9 – Grade 12 (SEE & NEB)",
    age: "Age 14 – 18 Years",

    image: "./images/c.jpg",

    desc: "Sahara prepares students for SEE and NEB examinations with specialised academic streams, career guidance, leadership opportunities and future-ready learning.",

    link: "/high-school",
  },
];

const SchoolLevels = () => {
  return (
    <>
      <SchoolHero
        title="SCHOOL LEVELS"
        subtitle="World-Class Infrastructure"
         image="./images/high.jpg"
      />

      <section className="school-levels">
        <div className="levels-container">
          {}

          <div className="levels-heading">
            <span>Sahara Public Secondary School • Nepal</span>

            <h1>School Levels</h1>

            <p>
              A complete learning journey from Early Childhood Education to
              Higher Secondary Education with academic excellence, values and
              innovation.
            </p>
          </div>

          {}

          {LEVELS.map((level, index) => (
            <div
              className={`level-section ${
                index % 2 === 0 ? "content-left" : "image-left"
              }`}

              key={level.title}
            >
              {}

              <div className="level-content">
                <span className="level-age">{level.age}</span>

                <h2>{level.title}</h2>

                <h4>{level.grade}</h4>

                <p>{level.desc}</p>

                {}

                <Link
                  to={level.link}

                  className="level-read-more"
                >
                  Read More →
                </Link>

                {}

                <div className="level-actions">
                  <Link to="/book-meeting">Book a Meeting</Link>

                  <Link to="/admissionenquiryform">Admission Form</Link>

                  <Link to="/feestructure">Fee Structure</Link>
                </div>
              </div>

              {}

              <div className="level-image">
                <img
                  src={level.image}

                  alt={level.title}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default SchoolLevels;
